<template>
  <v-simple-table outlined :dense='!notDense'>
    <thead></thead>
    <tbody>
      <tr v-for='(item, count) in items' :key='count' @click="$emit('rowClick', item)">
        <td class='grey--text text-left'>
          <span v-if='item.bold'><strong>{{ item.text }}</strong></span>
          <span v-else>{{ item.text }}</span>
        </td>
        <td v-if='item.error' class='red--text text-right'>
          <v-btn v-if='item.route' icon small :to='item.route'>
            <v-icon color='info' small>mdi-open-in-new</v-icon>
          </v-btn>
          <span v-if='item.bold'><strong>{{ item.value }}</strong></span>
          <span v-else>{{ item.value }}</span>
        </td>
        <td v-else class='text-right'>
          <v-btn v-if='item.route' icon small :to='item.route'>
            <v-icon color='info' small>mdi-open-in-new</v-icon>
          </v-btn>
          <span v-if='item.bold'><strong>{{ item.value }}</strong></span>
          <span v-else>{{ item.value }}</span>
        </td>
      </tr>
    </tbody>
  </v-simple-table>
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
      required: true
    },
    notDense: {
      required: false
    },
    route: {
      required: false
    }
  },
  created () {
    // this.formatItems()
  },
  methods: {
    formatItems () {
      for (var i = 0; i < this.items.length; i++) {
        if (!this.items[i].route) {
          this.items[i].route = ''
        }
      }
    },
    rowClick () {
      console.log("clicked")
    }
  }
}
</script>
